<template>
  <div id="appheader">
    <div class="mobile-h">
      <img
        @click="$router.push('/login')"
        :src="require('@img/tt-logo.png')"
        alt="天泰航空logo"
        title="天泰航空logo"
      />
      <van-icon
        :name="moreNavFlag ? 'cross' : 'wap-nav'"
        class="tt-mr10 nav tt-orange"
        @click="moreNavFlag = !moreNavFlag"
      />
    </div>
    <van-popup
      v-model="moreNavFlag"
      position="right"
      get-container="#mobile"
      :style="{ width: '70%', height: '100%', marginTop: '0.6rem' }"
    >
      <van-cell title="首页" is-link to="login" />
      <van-cell title="解决方案" is-link to="solution" />
      <van-cell title="企业案例" is-link to="corp" />
      <van-cell title="新闻动态" is-link to="news" />
      <van-cell title="关于我们" is-link to="aboutUs" />
      <van-cell title="下载中心" is-link to="download" />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'appheader',
  data () {
    return {
      moreNavFlag: false
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 加载基础数据
    async loadData () {}
  }
}
</script>
<style lang="less" scoped>
#appheader {
  height: 60px;
}
.mobile-h {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  background: #fff;
  .nav {
    font-size: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue